// src/components/MainNavbar.vue
<template>
    <nav class="navbar navbar-expand-lg bg-body-tertiary sticky-top">
        <div class="container-fluid">
            <!-- @if ( Auth::check() ) -->
            <a
                @click="
                    () => {
                        sidebarStore.toggleSidebar()
                        console.log(sidebarStore.isSidebarOpen)
                    }
                "
                id="sidebar-collapse-button"
            >
                <i class="fa-solid fa-list"></i>
            </a>

            <!-- @endif -->

            <a
                type="button"
                class="navbar-toggle m-2 d-lg-none"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <i class="bi bi-list"></i>
            </a>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="nav navbar-nav ml-auto">
                    <li class="nav-item" :class="{ active: $route.path === '/' }">
                        <RouterLink to="/" class="nav-link">Home</RouterLink>
                    </li>
                    <li class="nav-item">
                        <RouterLink to="/about" class="nav-link">About</RouterLink>
                    </li>
                    <li class="nav-item">
                        <RouterLink to="/playground" class="nav-link">Playground</RouterLink>
                    </li>
                </ul>
                <ul class="navbar-nav ms-md-auto d-lg-flex">
                    <ul class="nav navbar-nav ml-auto">
                        <li class="nav-item">
                            <div class="form-check form-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tipOfDayToggle"
                                    v-model="userStore.preferences.tipOfDay"
                                    @change="userStore.toggleTipOfDay"
                                />
                                <label class="form-check-label" for="tipOfDayToggle"
                                    >Tip of the Day</label
                                >
                            </div>
                        </li>
                        <li class="nav-item d-flex align-items-center mx-2">
                            <select
                                class="form-select form-select-sm"
                                style="width: auto; min-width: 110px"
                                :value="locale"
                                @change="changeLanguage"
                            >
                                <option
                                    v-for="lang in availableLanguages"
                                    :key="lang.code"
                                    :value="lang.code"
                                >
                                    {{ lang.label }}
                                </option>
                            </select>
                        </li>
                    </ul>
                    <!-- Debug: Show current user role badge (visible to all users during testing) -->
                    <li class="nav-item d-flex align-items-center me-2">
                        <small class="text-muted">
                            {{ currentUserRole }}
                            <span v-if="isPlatformStaff" class="badge bg-success ms-1"
                                >Full Access</span
                            >
                            <span v-else-if="isMspAdmin" class="badge bg-primary ms-1"
                                >MSP Admin</span
                            >
                            <span v-else-if="isSmeAdmin" class="badge bg-info ms-1">SME Admin</span>
                        </small>
                    </li>
                    <li class="nav-item dropdown drop-end">
                        <button
                            type="button"
                            class="nav-link dropdown-toggle"
                            id="navbarDropdownMenuLink"
                            data-bs-toggle="dropdown"
                            data-bs-boundary="viewport"
                            data-bs-popper="static"
                            aria-expanded="false"
                        >
                            <img
                                :src="`https://gravatar.com/avatar/${emailHash}?d=mp&s=25`"
                                class="rounded-circle me-1"
                                alt="Avatar"
                            />
                            {{ fullname }}
                        </button>

                        <ul
                            class="dropdown-menu dropdown-menu-end animate slideIn"
                            aria-labelledby="navbarDropdownMenuLink"
                            data-bs-popper="static"
                        >
                            <li>
                                <button
                                    type="button"
                                    class="dropdown-item"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#MyAccount"
                                    aria-controls="MyAccount"
                                >
                                    <i class="bi bi-person-circle me-3"></i> My Account
                                </button>
                            </li>

                            <li>
                                <a class="dropdown-item" href="#"
                                    ><i class="bi bi-sliders me-3"></i> Preferences</a
                                >
                            </li>
                            <li>
                                <a class="dropdown-item" href="#" @click="userStore.toggleTheme">
                                    <i class="fa-solid fa-circle-half-stroke me-3"></i>
                                    {{
                                        userStore.preferences.theme === 'dark'
                                            ? 'Light Mode'
                                            : 'Dark Mode'
                                    }}
                                </a>
                            </li>
                            <li><hr class="dropdown-divider" /></li>
                            <li>
                                <a class="dropdown-item" @click="logout" href="#"
                                    ><i class="fs-6 bi bi-box-arrow-left me-3"></i> Logout</a
                                >
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <div
        class="offcanvas offcanvas-end"
        tabindex="-1"
        id="MyAccount"
        aria-labelledby="offcanvasRightLabel"
    >
        <div class="offcanvas-header">
            <h5 id="offcanvasRightLabel">My Account</h5>
            <button
                type="button"
                class="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
            ></button>
        </div>
        <div class="offcanvas-body">
            <div class="row my-4 align-items-center">
                <div class="avatar col-sm-5 text-center text-md-left">
                    <a href="https://gravatar.com/" target="_blank">
                        <img
                            :src="`https://gravatar.com/avatar/${emailHash}?d=mp`"
                            class="rounded-circle"
                            alt="User Avatar"
                        />
                    </a>
                </div>
                <div
                    class="col-sm-7 d-flex flex-column justify-content-center text-center text-md-start"
                >
                    <span class="me-md-5 my-4 my-md-1">
                        <span class="editable-field">
                            <template v-if="!fullname">
                                <label for="name-input" class="form-label mb-1 small">{{
                                    t('account.setNameLabel')
                                }}</label>
                                <input
                                    id="name-input"
                                    v-model="nameInput"
                                    type="text"
                                    class="form-control form-control-sm"
                                    :placeholder="t('account.namePlaceholder')"
                                    :disabled="isSavingName"
                                    @blur="saveName"
                                    @keyup.enter="$event.target.blur()"
                                />
                            </template>
                            <template v-else-if="editingName">
                                <input
                                    id="name-input-edit"
                                    v-model="nameInput"
                                    type="text"
                                    class="form-control form-control-sm"
                                    :disabled="isSavingName"
                                    @blur="saveName"
                                    @keyup.enter="$event.target.blur()"
                                    @keyup.escape="cancelEditName"
                                />
                            </template>
                            <template v-else>
                                <b @click="startEditName">{{ fullname }}</b>
                                <button
                                    class="edit-btn btn btn-link p-0 ms-1"
                                    :aria-label="t('account.editName')"
                                    @click="startEditName"
                                >
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                            </template>
                        </span>
                        <br />
                        <span class="editable-field">
                            <template v-if="editingEmail">
                                <input
                                    id="email-input"
                                    v-model="emailInput"
                                    type="email"
                                    class="form-control form-control-sm"
                                    :disabled="isSavingEmail"
                                    @blur="saveEmail"
                                    @keyup.enter="$event.target.blur()"
                                    @keyup.escape="cancelEditEmail"
                                />
                            </template>
                            <template v-else>
                                <small @click="startEditEmail">{{ email }}</small>
                                <button
                                    class="edit-btn btn btn-link p-0 ms-1"
                                    :aria-label="t('account.editEmail')"
                                    @click="startEditEmail"
                                >
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                            </template>
                        </span>
                    </span>
                </div>
            </div>
            <hr />
            <div class="d-flex justify-content-center">
                <ul class="nav" style="align-items: flex-start">
                    <li class="nav-item">
                        <a class="nav-link py-0" href="#" @click="togglePasswordChange"
                            >Update your password</a
                        >
                    </li>
                </ul>
            </div>
            <hr />
            <PasswordChangeForm v-if="showPasswordChangeForm" />
        </div>
    </div>
    <tipOfTheDay
        :isVisible="showTipModal"
        :tipOfDay="tipOfDay"
        @close="showTipModal = false"
        :width="'35%'"
    >
    </tipOfTheDay>
</template>

<script setup>
import { ref, computed, onMounted, nextTick, defineAsyncComponent } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/stores/main'
import { useSidebarStore } from '@/stores/sidebar'
import { useUserStore } from '@/stores/user' // Import the updated user store
import { useAuthz } from '@/composables/useAuthz'
import { ROLES } from '@/config/roles'
import tipOfTheDay from '@/components/modals/TipOfTheDay.vue'
import { useI18n } from 'vue-i18n'
import { setLocale } from '@/i18n'
import { announce } from '@/utils/announce'
import { processError } from '@/composables/utils'
import { isValidEmail } from '@/utils/validationUtils'

// Use dynamic import for better code splitting
const PasswordChangeForm = defineAsyncComponent(
    () => import('@/views/Account/PasswordChangeForm.vue')
)

const sidebarStore = useSidebarStore()
const userStore = useUserStore() // Initialize the user store

// Tip of the day
const showTipModal = ref(false)
const tipOfDay = ref('')
// Commented out unused variables
// const currentTipId = ref(0)
// const userTimezone = ref('')

const { locale, t } = useI18n()
const availableLanguages = [
    { code: 'en', label: 'English (British)' },
    { code: 'en-us', label: 'English (US)' },
    { code: 'en-ie', label: 'English (Ireland)' },
    { code: 'en-au', label: 'English (Australia)' },
    { code: 'en-ca', label: 'English (Canada)' },
    { code: 'fr', label: 'Français' }
]

const changeLanguage = async (event) => {
    await setLocale(event.target.value)
}

// Apply the theme on component mount
onMounted(async () => {
    // Fetch user data if not already available
    if (!fullname.value) {
        //await mainStore.loadUserData()
    }
    await userStore.fetchPreferences() // Fetch preferences and apply theme
})

const mainStore = useMainStore()
const { claims } = storeToRefs(mainStore)
const { hasRole, isPlatformStaff } = useAuthz(claims)

// Role detection for badge display
const isMspAdmin = computed(() => {
    return hasRole(ROLES.TENANT.ADMIN) && mainStore.organization?.type === 'msp'
})

const isSmeAdmin = computed(() => {
    return hasRole(ROLES.TENANT.ADMIN) && mainStore.organization?.type === 'sme'
})

const currentUserRole = computed(() => {
    if (hasRole(ROLES.PLATFORM.ADMIN)) return 'Platform Administrator'
    if (hasRole(ROLES.PLATFORM.ENGINEER)) return 'Platform Engineer'
    if (isPlatformStaff.value) return 'Platform Staff'
    if (isMspAdmin.value) return 'MSP Administrator'
    if (isSmeAdmin.value) return 'SME Administrator'
    if (hasRole(ROLES.TENANT.ADMIN)) return 'Tenant Administrator' // Fallback for tenant admins
    if (hasRole(ROLES.TENANT.DOMAIN_GROUP_OWNER)) return 'Domain Group Owner'
    if (hasRole(ROLES.TENANT.DOMAIN_OWNER)) return 'Domain Owner'
    return 'User'
})

//const isAuthenticated = computed(() => mainStore.isAuthenticated)
const fullname = computed(() => mainStore.userData?.name || '')
const email = computed(() => mainStore.userData?.email || '')
const emailHash = computed(() => mainStore.userData?.email_hash || '')

const nameInput = ref('')
const isSavingName = ref(false)
const editingName = ref(false)

/**
 * Enters inline-edit mode for the display name.
 * Pre-fills the input with the current value and defers focus + full
 * text selection to the next DOM tick so the input is mounted first.
 */
const startEditName = () => {
    nameInput.value = fullname.value
    editingName.value = true
    nextTick(() => document.getElementById('name-input-edit')?.select())
}

/**
 * Cancels inline-edit mode for the display name without persisting changes.
 * Resets both the editing flag and the local input buffer.
 */
const cancelEditName = () => {
    editingName.value = false
    nameInput.value = ''
}

/**
 * Persists the edited display name to the backend via the main store.
 *
 * Early-returns (cancelling edit mode) if the trimmed value is empty or
 * unchanged. On success, announces a localised confirmation toast. On
 * failure, extracts a user-friendly message via `processError` and
 * announces it as an error. The `isSavingName` flag gates the save button
 * to prevent concurrent submissions.
 */
const saveName = async () => {
    const trimmed = nameInput.value.trim()
    if (!trimmed || trimmed === fullname.value) {
        cancelEditName()
        return
    }
    isSavingName.value = true
    try {
        await mainStore.updateUserData({ name: trimmed })
        announce(t('account.nameUpdateSuccess'), 'success')
        editingName.value = false
    } catch (error) {
        announce(processError(error, t('account.nameUpdateError')), 'error')
    } finally {
        isSavingName.value = false
    }
}

const emailInput = ref('')
const isSavingEmail = ref(false)
const editingEmail = ref(false)

/**
 * Enters inline-edit mode for the email address.
 * Pre-fills the input with the current value and defers focus + full
 * text selection to the next DOM tick so the input is mounted first.
 */
const startEditEmail = () => {
    emailInput.value = email.value
    editingEmail.value = true
    nextTick(() => document.getElementById('email-input')?.select())
}

/**
 * Cancels inline-edit mode for the email address without persisting changes.
 * Resets both the editing flag and the local input buffer.
 */
const cancelEditEmail = () => {
    editingEmail.value = false
    emailInput.value = ''
}

/**
 * Persists the edited email address to the backend via the main store.
 *
 * Early-returns (cancelling edit mode) if the trimmed value is empty or
 * unchanged. On success, announces a localised confirmation toast. On
 * failure, extracts a user-friendly message via `processError` and
 * announces it as an error. The `isSavingEmail` flag gates the save button
 * to prevent concurrent submissions.
 */
const saveEmail = async () => {
    const trimmed = emailInput.value.trim()
    if (!trimmed || trimmed === email.value) {
        cancelEditEmail()
        return
    }

    emailInput.value = trimmed
    if (!isValidEmail(trimmed)) {
        announce(t('account.invalidEmail'), 'error')
        return
    }

    isSavingEmail.value = true
    try {
        await mainStore.updateUserData({ email: trimmed })
        announce(t('account.emailUpdateSuccess'), 'success')
        editingEmail.value = false
    } catch (error) {
        announce(processError(error, t('account.emailUpdateError')), 'error')
    } finally {
        isSavingEmail.value = false
    }
}

// Reactive property for showing the password change form
const showPasswordChangeForm = ref(false)

// Function to toggle the password change form visibility
const togglePasswordChange = () => {
    showPasswordChangeForm.value = !showPasswordChangeForm.value
}

const router = useRouter()

const logout = async () => {
    await mainStore.logout()
    await router.push('/login')
}
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
    .animate {
        animation: slideIn 0.3s both;
    }
}

@keyframes slideIn {
    0% {
        transform: translateY(1rem);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

.editable-field {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    cursor: pointer;

    .edit-btn {
        opacity: 0;
        font-size: 0.7rem;
        color: var(--bs-secondary);
        line-height: 1;
        transition: opacity 0.15s ease;
    }

    &:hover .edit-btn {
        opacity: 1;
    }

    // Touch devices: always show the icon
    @media (hover: none) {
        .edit-btn {
            opacity: 1;
        }
    }
}
</style>
